import React from 'react'
import { BrowserRouter as Router, Route, RouteComponentProps, Switch } from 'react-router-dom'

import { RouteType } from '../types/routes'
import Page404 from '../pages/Page404'
import { usePageTracking } from '../hooks/usePageTracking'

import { defaultLayoutRoutes } from './routes'

const childRoutes = (routes: Array<RouteType>) =>
  routes.map(({ component: Component, guard, children, path }, index: number) => {
    let Guard = guard || React.Fragment

    return children ? (
      children.map((element, index: number) => {
        Guard = element.guard || Guard
        const ElementComponent = element.component || React.Fragment

        return (
          <Route
            key={index}
            path={element.path}
            exact
            render={(props: RouteComponentProps) => (
              <Guard>
                <ElementComponent {...props} />
              </Guard>
            )}
          />
        )
      })
    ) : Component ? (
      <Route
        key={index}
        path={path}
        exact
        render={(props) => (
          <Guard>
            <Component {...props} />
          </Guard>
        )}
      />
    ) : null
  })

const AppRoutes = () => {
  usePageTracking()

  return (
    <Switch>
      {childRoutes(defaultLayoutRoutes)}
      <Route render={() => <Page404 />} />
    </Switch>
  )
}

const RoutesComponents = () => (
  <Router>
    <AppRoutes />
  </Router>
)

export default RoutesComponents
